import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "./common";
import { Image } from "../../schema/types/image/entity";

export const imageApi = createApi({
  reducerPath: "imageApi",
  baseQuery: customBaseQuery,
  tagTypes: ["Image"],
  endpoints: (builder) => ({
    getImage: builder.query<Image, string>({
      queryFn: async (imageLink) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({ url: imageLink });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, imageLink) => [{ type: "Image", id: imageLink }],
    }),
  }),
});

export const { useGetImageQuery } = imageApi;
